module.exports = __webpack_public_path__ + "static/media/Shelf.e83c08c8.svg";